import { getGeolocation } from './getGeolocation'

export const getLocation = async () => {
  const country = await getGeolocation()
  return country.country_code ? country.country_code : null
}

export default getLocation
